import {
  BannerInlinePlaceholder,
  IBannerInlinePlaceholderProps,
} from '@tekface/smart-activation';
import { styled } from '@teko/ds-desktop';
import { getInlineBannerMinHeight } from 'helpers';
import React from 'react';

interface InlineBannerProps {
  inlineBanners?: IBannerInlinePlaceholderProps<{}>['banners'];
  inlineBannerClass: string;
}

export const InlineBanner: React.FC<InlineBannerProps> = ({
  inlineBanners,
  inlineBannerClass,
}) => {
  return (
    <BannerInlinePlaceholderStyled
      banners={inlineBanners}
      className={`${inlineBannerClass} inline-banner`}
      minHeight={getInlineBannerMinHeight(inlineBanners, inlineBannerClass)}
    />
  );
};

const BannerInlinePlaceholderStyled = styled(BannerInlinePlaceholder)(
  ({ minHeight }: { minHeight: number }) => `
  &.inline-banner {
    width: 100% !important;
    min-height: ${minHeight}px !important;
    picture {
      width: 100%;
      object-fit: contain;
    }
  }
`,
);
